import { Text } from "core-library/Text/Text";

interface WarningProps {
  text: string;
}
export const Warning = ({ text }: WarningProps) => {
  return <Text variant="inputHint" color="basic.greyMedium" />;
};
